import { Outlet } from 'react-router-dom';
import ExtensionRoute from '../../modules/core/public/ExtensionRoute';

export default function OperationalPurchasesRoutes() {
  return (
    <ExtensionRoute extensionId="operational-purchases">
      <Outlet />
    </ExtensionRoute>
  );
}
